// =========================================================
// * Vue Material Dashboard PRO - v1.4.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";
import VueLodash from "vue-lodash";
import lodash from "lodash";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";

// router setup
import routes from "./routes/routes";
//Auth0
import { domain, clientId, audience } from "../auth_config.json";
import { Auth0Plugin } from "./auth/index";
import i18n from "./i18n";
import store from "./store";
import VueCookies from "vue-cookies";

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);

Vue.use(VueLodash, { lodash: lodash });
Vue.use(VueCookies);

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  },
});

Vue.config.errorHandler = (err, vm, info) => {

    if (err.message !== "Cannot read property 'badInput' of undefined") {
      console.error(err);
    }
  
};

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active",
  mode: "history",
});

// global library setup
Vue.prototype.$Chartist = Chartist;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  i18n,
  router,
  store,
});
